/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { AnyAction } from 'redux';
import { AUTH_LOGOUT } from '../../../constants/auth.constants';
import { UPDATE_TRAINING, CLEAR_TRAINING, UPDATE_SINGLE_TRAINING } from '../../../constants/training.constants';
import TrainingState from '../../../models/redux/state/training.state';

const initialState: TrainingState = {
  current: undefined,
};

const trainingReducer = produce((draft: TrainingState, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_TRAINING:
      draft.current = action.training;
      break;
    case UPDATE_SINGLE_TRAINING:
      if (draft.current) {
        const matchIndex = draft.current?.trainings.findIndex((item) => item.id === action.training.id);
        if (matchIndex >= 0) {
          draft.current.trainings[matchIndex] = action.training;
        }
      }
      break;
    case CLEAR_TRAINING:
      draft.current = initialState.current;
      break;
    case AUTH_LOGOUT:
      draft.current = initialState.current;
      break;
    default:
  }
}, initialState);

export default trainingReducer;
